module.exports = __webpack_public_path__ + "media/images/users-20b6aaa72ecce233a05e361606e267cc.svg";